import SigninComponent from "components/signinComponent/SigninComponent";

function Signin() {
  return (
    <div>
      <SigninComponent />
    </div>
  );
}

export default Signin;
